import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2f25ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event_body-dates" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", null, [
      _createTextVNode(_toDisplayString(_ctx.start.local().format("l LT")) + " ", 1),
      (_ctx.end.isValid())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" to " + _toDisplayString(_ctx.end.local().format("l LT")), 1)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}